module.exports = __webpack_public_path__ + "static/img/年度最佳蒸烤一体机.0da4c333.png";